<script>
export default {
    name: "Comments",
    data() {
        return {
            axios: this.$http,
            base_url: '',
            erps: {data: [], total: 0},
            count: 0,

            commenting: false,
            commentsInput: {},
        };
    },

    mounted() {
        this.loadComments();
    },

    methods: {
        loadComments(page = 1) {
            this.wait = true;
            this.axios.get(`${this.base_url}/comments?page=${page}`)
                .then(res => {
                    this.erps = res.data.data.erps;
                    this.count = res.data.data.count;
                })
                .catch(error => {
                    this.showError(error);
                })
                .finally(() => {
                    this.wait = false;
                });
        },
        markAsRead(comment) {
            if (comment.read === 0) {
                this.axios.post(`${this.base_url}/comments/read`, {id: comment.id}).then(() => {
                    comment.read = 1;
                });
            }
        },
        leaveComment(code) {
            if (!this.commentsInput[code]) return;
            this.commenting = true;

            this.axios.post(`/request/${code}/comments`, {
                comment: this.commentsInput[code],
                code: code
            }).then(() => {
                this.loadComments();
                this.commentsInput[code] = '';
            }).catch(error => {
                console.error("Error posting comment:", error);
            }).finally(() => {
                this.commenting = false;
            });
        }
    }
};
</script>

<template>
    <div>
        <h4 class="font-weight-bold mb-0">Comments</h4>
        <p class="text-muted">
            <span class="float-right">{{ count }} comments</span>
            View available comments grouped by ERP requests
        </p>

        <div v-if="wait" class="spinner-border spinner-border-sm mr-2"></div>

        <div v-for="erp in erps.data" :key="erp.code" class="mb-4 shadow-sm bg-white rounded-lg">
            <div class="p-3">
                <div class="text-muted mb-2">
                    <h6>
                        <span class="font">{{ erp.currency }} {{ erp.amount }}</span>
                        &nbsp;&nbsp;<small class="font-weight-bold small">{{ erp.code }}</small>
                    </h6>
                    <small class="border-bottom">{{ erp.title }}</small>
                </div>

                <div class="small">
                    {{ new Date(erp.created_at).toLocaleString() }} by {{ erp.user.name }}
                    &nbsp;&nbsp;
                    <a v-if="base_url=='/api'" :href="`request/${erp.code}/comments`">More &raquo;</a>
                    <router-link v-else :to="`/requests/${erp.code}`">More &raquo;</router-link>
                </div>
            </div>

            <div v-if="erp.comments.length" class="bg-light">
                <div v-for="comment in erp.comments" :key="comment.id" class="p-2 px-3 border-bottom d-flex"
                     @click="markAsRead(comment)">
                    <div class="mr-2">
                        <img :src="comment.user.avatar" class="rounded-circle mb-2 p-1 border d-block"
                             style="height: 42px;">
                    </div>
                    <div class="flex-fill">
                        <div class="small text-muted">
                            {{ new Date(comment.created_at).toLocaleString() }} by {{ comment.user.name }}
                        </div>
                        <div :class="comment.read == 0 ? 'font-weight-bold' : ''">{{ comment.comment }}</div>
                    </div>
                </div>
            </div>

            <div class="p-2 px-3 border-bottom d-flex">
                <div class="mr-2"></div>
                <div class="flex-fill">
                    <div class="small text-muted">
                        <textarea class="form-control rounded-lg mb-2"
                                  placeholder="Leave a comment..."
                                  rows="2"
                                  v-model="commentsInput[erp.code]"></textarea>
                        <button class="btn btn-sm" v-if="commentsInput[erp.code]" @click="leaveComment(erp.code)">
                            <div v-if="commenting" class="spinner-border spinner-border-sm mr-2"></div>
                            Comment
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <pagination :data="erps" @pagination-change-page="loadComments" :limit="1"></pagination>
    </div>
</template>

<style scoped>
.ml-4 {
    margin-left: 1.5rem;
}
</style>

